import { EditorContent } from '@tiptap/react';

import { ComposerEditorControls } from '@/components/blocks/Thread/composer-editor-controls';
import {
  type ComposerEditorOptions,
  useComposerEditor,
} from '@/components/blocks/Thread/useComposerEditor';
import { classList } from '@/utils/cn';
import { COMPOSER_TEXTAREA_MAX_HEIGHT } from '@/utils/constants';

type AgentsComposerEditorProps = ComposerEditorOptions & {
  placeholder: string;
  expanded?: boolean;
};

export const AgentsComposerEditor = ({
  placeholder,
  expanded,
  ...editorOptions
}: AgentsComposerEditorProps) => {
  const { value, disabled } = editorOptions;
  const editor = useComposerEditor(editorOptions);

  return (
    <div
      className={classList(
        'relative w-full min-w-0 overflow-y-auto text-[13px] leading-6 text-foreground',
        expanded ? 'px-2' : 'px-0.5',
        disabled && 'opacity-60'
      )}
      style={{ maxHeight: `${COMPOSER_TEXTAREA_MAX_HEIGHT}px` }}
    >
      {value.length === 0 && (
        <span className="pointer-events-none absolute top-0.5 select-none text-foreground-muted">
          {placeholder}
        </span>
      )}
      <ComposerEditorControls editor={editor}>
        <EditorContent editor={editor} />
      </ComposerEditorControls>
    </div>
  );
};
